<div class="tasks">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8"><router-outlet></router-outlet></div>
    </div>
  </div>
</div>
